<div class="data-protection-rules">

    <sc-master-detail [selection]="[selectedRule]" [data]="rules"
        (selectionChanged)="onSelectionChanged($event);" (addEntry)="onAddEntry($event);" [newStyle]="true"
        (deleteEntry)="onDeleteEntry($event);">

        <div class="data-protection-rule-details">
          <app-service-response [responseMessages]="responseMessages"></app-service-response>
            <div class="form-box" [formGroup]="detailsForm">

                <sc-flex [vertical]="true" [stretchContent]="true">

                    <mat-form-field>
                        <input matInput name="name" formControlName="name"
                            placeholder="{{'name' | translate:['tmc-yard.widgets.data-protection-rules.name', translationService.language]}}"
                            [required]="true" [maxLength]="255">
                    </mat-form-field>

                    <mat-checkbox class="form-checkbox" name="defaultRule" formControlName="defaultRule">
                        {{'default rule' | translate: ['tmc-yard.widgets.data-protection-rules.default-rule',
                        translationService.language]}}
                    </mat-checkbox>

                    <mat-checkbox class="form-checkbox" name="disabled" formControlName="disabled">
                        {{'disabled' | translate: ['tmc-yard.widgets.data-protection-rules.disabled',
                        translationService.language]}}
                    </mat-checkbox>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="phoneEnabled"
                            formControlName="phoneEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="phone" formControlName="phone"
                                placeholder="{{'phone' | translate:['tmc-yard.widgets.data-protection-rules.phone', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="numberPlateEnabled"
                            formControlName="numberPlateEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="numberPlate" formControlName="numberPlate"
                                placeholder="{{'number plate' | translate:['tmc-yard.widgets.data-protection-rules.number-plate', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="trailerNumberPlateEnabled"
                            formControlName="trailerNumberPlateEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="trailerNumberPlate" formControlName="trailerNumberPlate"
                                placeholder="{{'trailer number plate' | translate:['tmc-yard.widgets.data-protection-rules.trailer-number-plate', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="swapTrailerNumberEnabled"
                            formControlName="swapTrailerNumberEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="swapTrailerNumber" formControlName="swapTrailerNumber"
                                placeholder="{{'swap trailer number' | translate:['tmc-yard.widgets.data-protection-rules.swap-trailer-number', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="driverEnabled"
                            formControlName="driverEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="driver" formControlName="driver"
                                placeholder="{{'driver' | translate:['tmc-yard.widgets.data-protection-rules.driver', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="coDriverEnabled"
                            formControlName="coDriverEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="coDriver" formControlName="coDriver"
                                placeholder="{{'co driver' | translate:['tmc-yard.widgets.data-protection-rules.co-driver', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="carrierEnabled"
                            formControlName="carrierEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="carrier" formControlName="carrier"
                                placeholder="{{'carrier' | translate:['tmc-yard.widgets.data-protection-rules.carrier', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="supplierEnabled"
                            formControlName="supplierEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="supplier" formControlName="supplier"
                                placeholder="{{'supplier' | translate:['tmc-yard.widgets.data-protection-rules.supplier', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="identityCardEnabled"
                            formControlName="identityCardEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="identityCard" formControlName="identityCard"
                                placeholder="{{'identity card' | translate:['tmc-yard.widgets.data-protection-rules.identity-card', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="mailEnabled"
                            formControlName="mailEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="mail" formControlName="mail"
                                placeholder="{{'mail' | translate:['tmc-yard.widgets.data-protection-rules.mail', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                    <div class="rule-option">
                        <mat-checkbox class="form-checkbox option-checkbox" name="resourcesEnabled"
                            formControlName="resourcesEnabled">
                        </mat-checkbox>
                        <mat-form-field class="option-value">
                            <input matInput name="resources" formControlName="resources"
                                placeholder="{{'resources' | translate:['tmc-yard.widgets.data-protection-rules.resources', translationService.language]}}"
                                [required]="true" min="0" appPositiveInteger type="NUMBER">
                        </mat-form-field>
                    </div>

                </sc-flex>
            </div>
        </div>

        <ng-template masterDetailToolbar>
            <button mat-stroked-button type="button" class="config-changed-button" (click)="cancel()"
                [disabled]="!cancelEnabled">{{'cancel' |
                translate: ['tmc.admin.smartphone.action.cancel', translationService.language]}}</button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-flat-button type="button" class="config-changed-button" (click)="save()"
                [disabled]="!saveEnabled">{{'save' |
                translate: ['tmc.admin.smartphone.action.save', translationService.language]}}</button>
        </ng-template>

    </sc-master-detail>

</div>
